import React from "react";
import { useEffect, useState } from "react";
import Unsubscribed from "../components/SubscriptionStates/Unsubscribed";
import PaymentSuccessful from "../components/SubscriptionStates/PaymentSuccessful";
import PaymentError from "../components/SubscriptionStates/PaymentError";
import { loadStripe } from "@stripe/stripe-js";
import { useApiClient } from "../../../api";
import { enqueueSnackbar } from "notistack";
import GeneralLoading from "../../../shared-components/Loading";
import {
  FruitifyContainer,
  FruitifyStack,
} from "../../../shared-components/Containers";
import { useNavigate } from "react-router-dom";
import { useAuthenticationStore } from "../../../stores/auth";

let stripePromise;

const getStripe = (key) => {
  if (!stripePromise) {
    stripePromise = loadStripe(key);
  }
  return stripePromise;
};

export default function Subscriptions() {
  const ApiClient = useApiClient();
  const [redirecting, setRedirecting] = useState(false);
  const [subscriptionView, setSubscriptionView] = useState("unsubscribed");
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const { updateUserInfo } = useAuthenticationStore();
  const navigate = useNavigate();

  const getPossibleSubscriptions = async () => {
    try {
      const result =
        await ApiClient.subscriptions.getPossibleUserSubscriptionPlans();
      if (result) {
        setSubscriptionPlans(result);
      }
    } catch (error) {
      console.error("Failed to fetch possible subscriptions", error);
    }
  };

  const handleStripeCheckout = async (stripePriceId) => {
    console.log(stripePriceId);
    try {
      setRedirecting(true);
      const stripeKey = await ApiClient.subscriptions
        .getPaymentInfo()
        .then((res) => res.publicKey);
      const checkoutSession = await ApiClient.subscriptions
        .createCheckoutSession({
          successUrl: `${window.location.origin}/account/subscriptions?success`,
          cancelUrl: `${window.location.origin}/account/subscriptions?cancel`,
          stripePriceId: stripePriceId,
        })
        .then((res) => res.sessionId);
      const stripe = await getStripe(stripeKey);
      if (stripe) {
        stripe.redirectToCheckout({ sessionId: checkoutSession });
      }
    } catch (error) {
      console.error("Stripe checkout failed", error);
      enqueueSnackbar("Payment cancelled!", {
        variant: "error",
        autoHideDuration: 3000,
      });
      setRedirecting(false);
    }
  };

  const resetUserSubscription = async () => {
    try {
      const response = await ApiClient.users.clearSubscriptionCache();
      if (response.success) {
        const userData = await ApiClient.users.me();
        updateUserInfo(userData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (location.search.includes("success")) {
      enqueueSnackbar("Payment successful!", {
        variant: "success",
        autoHideDuration: 3000,
      });
      resetUserSubscription();
      setSubscriptionView("paymentSuccessful");
    } else if (location.search.includes("cancel")) {
      enqueueSnackbar("Payment cancelled!", {
        variant: "error",
        autoHideDuration: 3000,
      });
      resetUserSubscription();
      setSubscriptionView("paymentError");
    } else {
      getPossibleSubscriptions();
    }
  }, []);

  if (redirecting) {
    return (
      <FruitifyStack>
        <GeneralLoading message={"Redirecting..."} />
      </FruitifyStack>
    );
  }

  return (
    <FruitifyContainer>
      {subscriptionView === "unsubscribed" && (
        <Unsubscribed
          handleStripeCheckout={handleStripeCheckout}
          subscriptionPlans={subscriptionPlans}
        />
      )}
      {subscriptionView === "paymentSuccessful" && (
        <PaymentSuccessful onGoToAccounts={() => navigate(`/account/home`)} />
      )}
      {subscriptionView === "paymentError" && (
        <PaymentError onRetry={handleStripeCheckout} />
      )}
    </FruitifyContainer>
  );
}
